// src/services/barterFiSurveyApi.js

import api from '../api';

const MAINNET_CONFIG = {
  headers: {
    'X-Network': 'mainnet',
  },
};

export function getBarterFiSurveyStatus() {
  return api.get(
    '/barterfi-survey/status',
    MAINNET_CONFIG
  );
}

export function recordBarterFiSurveyOpen() {
  return api.post(
    '/barterfi-survey/open',
    {},
    MAINNET_CONFIG
  );
}

export function dismissBarterFiSurvey() {
  return api.post(
    '/barterfi-survey/dismiss',
    {},
    MAINNET_CONFIG
  );
}

export function submitBarterFiSurvey({
  answers,
  optionalFeedback,
}) {
  return api.post(
    '/barterfi-survey/submit',
    {
      answers,
      optionalFeedback,
    },
    MAINNET_CONFIG
  );
}

export function recordBarterFiStakeClick() {
  return api.post(
    '/barterfi-survey/stake-click',
    {},
    MAINNET_CONFIG
  );
}
